import React, { useEffect, useState } from 'react';
import PageHeaderText from 'components/base/page-header-text';
import { ReactComponent as BrandDetailsIcon } from 'assets/icons/brand-details.svg';
import { ReactComponent as MealDetailsIcon } from 'assets/icons/meals.svg';
import { ReactComponent as MetadataIcon } from 'assets/icons/metadata.svg';
import { Outlet, useParams } from 'react-router-dom';
import useDashboardContext from 'contexts/dashboard.context';
import { ROUTE_KEYS } from 'utils/constants';
import RightSidebar from 'components/right-sidebar';
import BottomNavigation from 'components/bottom-navigation';
import { apiService } from 'services/base.service';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { toast } from 'react-toastify';
import { SuccessModal } from 'components/base/success-modal';
import useMealContext from 'contexts/meal.context';

const NewMealContent = () => {
  const { brand_id, meal_cat_id } = useParams();
  const { setRightSection, setMealInfo, category } = useDashboardContext();
  const [loading, setLoading] = useState(false);
  const { formData, disabled } = useMealContext();
  const [showSuccess, setShowSuccess] = useState(false);
  const brand_link =
    brand_id && meal_cat_id
      ? `${ROUTE_KEYS.NEW_MEAL_BRAND_DETAILS}/${brand_id}/${meal_cat_id}`
      : ROUTE_KEYS.NEW_MEAL_BRAND_DETAILS;
  const MEAL_NAV_LIST = [
    {
      title: 'Brand details',
      link: `${ROUTE_KEYS.NEW_MEAL}/${brand_link}`,
      Icon: BrandDetailsIcon
    },
    {
      title: 'Meal details',
      link: `${ROUTE_KEYS.NEW_MEAL}/${ROUTE_KEYS.NEW_MEAL_DETAILS}`,
      Icon: MealDetailsIcon
    },
    {
      title: 'Metadata info',
      link: `${ROUTE_KEYS.NEW_MEAL}/${ROUTE_KEYS.NEW_MEAL_METADATA}`,
      Icon: MetadataIcon
    }
  ];

  const addMeal = async () => {
    setLoading(true);
    setMealInfo([]);
    /* eslint-disable */
    const {
      brand_id,
      meal_category_id,
      meal_descriptive_metadatas,
      meal_business_metadatas,
      meal_keywords,
      available_no,
      base_meal_id,
      budget_combo,
      ...formDataWithoutBrandId
    } = formData;
    /* eslint-enable */
    try {
      await apiService.post('marketing/meal-new', {
        data: {
          base_meal_id: base_meal_id[0],
          item_type: category.toUpperCase(),
          brand_id: brand_id[0],
          budget_combo: budget_combo,
          ...formDataWithoutBrandId,
          meal_category_id: meal_category_id[0],
          ...(meal_descriptive_metadatas?.length && { meal_descriptive_metadatas }),
          ...(meal_business_metadatas?.length && { meal_business_metadatas }),
          ...(meal_keywords?.length && { meal_keywords }),
          ...(formData?.images?.length && { images: formData.images }),
          ...(available_no ? { available_no } : { available_no: 'INFINITE' })
        }
      });

      setShowSuccess(true);
    } catch {
      toast(<ToastMessage type='error' message='There was a problem adding meal' />);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    setRightSection(<RightSidebar list={MEAL_NAV_LIST} />);

    return () => {
      setRightSection(null);
    };
  }, []);
  return (
    <div>
      <PageHeaderText
        title='Add New Meal'
        description='Create a new meal by filling in the form below.'
      />
      <Outlet />
      <BottomNavigation
        list={MEAL_NAV_LIST}
        loading={loading}
        onConfirm={addMeal}
        disabled={disabled}
      />
      <SuccessModal onClose={() => setShowSuccess(false)} show={showSuccess}>
        Meal added successfully
      </SuccessModal>
    </div>
  );
};

export default NewMealContent;
